<template>
    <div class="story-maker-sticker-menu-select">
        <div class="search-bar">
            <i class="fa-regular fa-magnifying-glass"></i>
            <input :placeholder="$t('dash.post-creator.overlay.search')" v-model="models.search">
        </div>
        <div class="list hide-scrollbar">
            <div class="list-action" v-if="Object.values(actionMatchSeachValue).some(bool => (bool))">
                <div v-if="actionMatchSeachValue.localisation" class="action localisation" :class="{disabled: !pagesSelectedIncludeConciergerie }" @click="()=>pagesSelectedIncludeConciergerie && $emit('changeMenu','localisationMenu')">
                    <div class="icon"></div>
                    <p>{{ $t('dash.post-creator.story.sticker.localisation') }}</p>
                </div>
  
                <div v-if="actionMatchSeachValue.mention" class="action mention":class="{disabled: !pagesSelectedIncludeConciergerie }" @click="()=>pagesSelectedIncludeConciergerie && addSticker('mention')">
                    <div class="icon"></div>
                    <p>{{ $t('dash.post-creator.story.sticker.mention') }}</p>
                </div>
  
                <div v-if="actionMatchSeachValue.gif" class="action gif" :class="{disabled: !pagesSelectedIncludeConciergerie }" @click="()=>pagesSelectedIncludeConciergerie && $emit('changeMenu','gifMenu')">
                    <div class="icon"></div>
                    <p>GIF</p>
                </div>
  
                <div v-if="actionMatchSeachValue.music" class="action music" :class="{disabled: !pagesSelectedIncludeConciergerie }" @click="()=>pagesSelectedIncludeConciergerie && $emit('changeMenu','musicMenu')">
                    <div class="icon"></div>
                    <p>{{ $t('dash.post-creator.story.sticker.music') }}</p>
                </div>
  
                <div v-if="actionMatchSeachValue.survey" class="action survey" :class="{disabled: !pagesSelectedIncludeConciergerie }" @click="()=>pagesSelectedIncludeConciergerie && addSticker('survey')">
                    <div class="icon"></div>
                    <p>{{ $t('dash.post-creator.story.sticker.survey') }}</p>
                </div>
                <div v-if="actionMatchSeachValue.slider" class="action slider" :class="{disabled: !pagesSelectedIncludeConciergerie }" @click="()=>pagesSelectedIncludeConciergerie && addSticker('slider')">
                    <div class="container-bar">
                        <div class="container-progress"><div class="progress"></div></div>
                        <span class="emoji">😍</span>
                    </div>
                </div>
                
                <Tooltip 
                    v-if="actionMatchSeachValue.link" 
                    :active="stickerProduct !== undefined"
                    :text="$t('dash.post-creator.story.sticker.impossible-product-and-link')"
                    :position="'bottom'" 
                    key="action-link" 
                    :classCustom="`action link ${!pagesSelectedIncludeConciergerie && 'disabled'}`"
                    @click="()=> pagesSelectedIncludeConciergerie && !stickerProduct && $emit('changeMenu','linkMenu')"
                >
                    <div class="icon"></div>
                    <p>{{ $t('dash.post-creator.story.sticker.link') }}</p>
                </Tooltip>
                
                <div v-if="actionMatchSeachValue.hashtag" class="action hashtag" :class="{disabled: !pagesSelectedIncludeConciergerie }" @click="()=>pagesSelectedIncludeConciergerie && addSticker('hashtag')">
                    <div class="icon"></div>
                    <p>hashtag</p>
                </div>
                <div v-if="actionMatchSeachValue.picture" class="action picture" :class="{disabled: !pagesSelectedIncludeConciergerie }" @click="()=>pagesSelectedIncludeConciergerie && $emit('changeMenu','imageMenu')">
                    <div class="icon"></div>
                    <p>{{ $t('dash.post-creator.story.sticker.photo') }}</p>
                </div>
                <div v-if="actionMatchSeachValue.text" class="action text" @click="()=>addSticker('text')">
                    <div class="icon"></div>
                    <p>{{ $t('dash.post-creator.story.sticker.text') }}</p>
                </div>

                <Tooltip 
                    v-if="actionMatchSeachValue.link" 
                    :active="stickerLink !== undefined"
                    :text="$t('dash.post-creator.story.sticker.impossible-link-and-product')"
                    :position="'bottom'" 
                    key="action-product" 
                    :classCustom="`action product ${!pagesSelectedIncludeConciergerie && 'disabled'}`"
                    @click="()=> pagesSelectedIncludeConciergerie && !stickerLink && $emit('changeMenu','productMenu')"
                >
                    <div class="icon"></div>
                    <p>{{ $t('dash.post-creator.story.sticker.product') }}</p>
                </Tooltip>

                <div v-if="actionMatchSeachValue.question" class="action question" :class="{disabled: !pagesSelectedIncludeConciergerie }" @click="()=>pagesSelectedIncludeConciergerie && addSticker('question')">
                    <div class="icon"></div>
                    <p>{{ $t('dash.post-creator.story.sticker.question') }}</p>
                </div>

                <div v-if="actionMatchSeachValue.countdown" class="action countdown" :class="{disabled: !pagesSelectedIncludeConciergerie }" @click="()=>pagesSelectedIncludeConciergerie && addSticker('countdown')">
                    <div class="icon"></div>
                    <p>{{ $t('dash.post-creator.story.sticker.countdown') }}</p>
                </div>
                <Tooltip 
                    v-if="actionMatchSeachValue.post"
                    :active="stickerPublication !== undefined"
                    :text="$t('dash.post-creator.story.sticker.impossible-duplicate')"
                    :position="'bottom'" 
                    key="action-link" 
                    :classCustom="`action post ${!pagesSelectedIncludeConciergerie && 'disabled'}`"
                    @click="()=> pagesSelectedIncludeConciergerie && !stickerPublication && $emit('changeMenu','postMenu')"
                >
                    <div class="icon"></div>
                    <p>{{ $t('dash.post-creator.story.sticker.publication') }}</p>
                </Tooltip>
            </div>

            <div class="list-stickers" v-if="pagesSelectedIncludeConciergerie">
                <span class="loader" v-if="loading"></span>
                <template v-else-if="models.search.length || (dataInstagramDefault.gifs && dataInstagramDefault.gifs.length)">
                    <div class="gif" v-for="gif in (models.search.length ? gifs : dataInstagramDefault.gifs)" :key="gif.id">
                        <div v-if="!gifLoaded[gif.id]" class="loader"></div>
                        <img 
                            :src="gif.images.preview_gif ? gif.images.preview_gif.url : gif.images.original.url" 
                            :key="'img'+gif.id"
                            @load="()=>{ $set(gifLoaded, gif.id, true)}"
                            v-show="gifLoaded[gif.id]"
                            @click="addGif(gif)"
                        >
                    </div>
                </template>
              
            </div>
        </div>
    </div>
</template>
  
<script>
    import store from '@/store/index.js';
    import minxinPost from '@/components/mixins/Posts.vue'
    import Tooltip from '@/components/dash/tooltip/tooltipInit.vue'
    
    export default {
        mixins: [minxinPost],
        components: {
            Tooltip,
        },
        props: {
            dataInstagramDefault: Object,
            stickers: Array,
            pagesSelectedIncludeConciergerie: Boolean
        },
       
        data() {
            return {
                models: {
                    search: '',
                },
                gifs: [],
                timeout: null,
                loading: false,
                gifLoaded:{}
            }
        },
        methods: {
            addSticker(name) {
                this.$emit('addSticker', name)
            },

            async searchGif() {
                if (this.timeout) clearTimeout(this.timeout)
                this.gifs = []
                this.loading = false
                if (!this.models.search) return 
                this.loading = true

                this.timeout = setTimeout(async () => {
                    let page = this.pagesSelected.find(p => p.network == 'instagram' && p.story_config && p.story_config.created)
                    if (page) {
                        try {
                            this.gifs = (await this.searchGifsInstagram(page.id, this.models.search)).body.gifs.results.giphy
                        } catch (error) {}
                        this.loading = false
                    }
                },1000)
            },

            addGif(gif) {
                this.$emit('addSticker','gif', {
                    data: {
                        gif: gif,
                    }
                })
            }
        },


        computed: {
            allPages() {
                return this.$store.getters['selectPage/selectPageAllPages'];
            },
            pagesSelected() {
                return this.$store.getters['selectPage/selectPagePageSelected'].map(id => this.allPages[id]);
            },

            actionMatchSeachValue() {
                const searchIsEmpty = !this.models.search || this.models.search.length == 0
                let match = {
                    localisation: searchIsEmpty,
                    mention: searchIsEmpty,
                    gif: searchIsEmpty,
                    music: searchIsEmpty,
                    survey: searchIsEmpty,
                    slider: searchIsEmpty,
                    link: searchIsEmpty,
                    hashtag: searchIsEmpty,
                    picture: searchIsEmpty,
                    product: searchIsEmpty,
                    text: searchIsEmpty,
                    question: searchIsEmpty,
                    countdown: searchIsEmpty,
                    post: searchIsEmpty,
                }

                if (!searchIsEmpty) {
                    Object.keys(match).forEach(actionName => {
                        match[actionName] = actionName.indexOf(this.models.search.trim().toLowerCase()) >= 0
                    });
                }

                return match
            },

            stickerProduct() {
                return this.stickers.find(sticker => sticker.type == 'product') 
            },

            stickerLink() {
                return this.stickers.find(sticker => sticker.type == 'link') 
            },

            stickerPublication() {
                return this.stickers.find(sticker => sticker.type == 'post')
            },

            isProd() {
                return process.env.VUE_APP_API_HOST == 'https://api.saas.mashup-web.com'
            }
            
        },

        watch: {
            ['models.search'](newValue, oldValue) {
                this.searchGif()
            },
        }
    }
  
</script>